module.exports = __webpack_public_path__ + "media/images/logos/stem-logo-with-bg-197f7be818296a4ff191d47f4d7ec70e.svg";